import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  assignmentDimensions: {
    paddingTop: pxToRem(20),
  },

  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
    paddingTop: pxToRem(20),
  },
  cancelButton: {
    backgroundColor: theme.palette.neutralWhite,
    color: theme.palette.themePrimary,
    border: pxToRem(0),
    paddingLeft: pxToRem(20),
    paddingRight: pxToRem(20),
  },
  errorBar: {
    paddingBottom: pxToRem(20),
  },
  errorRow: {
    background: 'red',
  },
  dimensionsContainer: { background: theme.palette.neutralLighterAlt },
  dimensionsSelector: {
    marginLeft: pxToRem(20),
    marginRight: pxToRem(20),
    paddingTop: pxToRem(20),
    paddingBottom: pxToRem(20),
  },
  fee: {
    background: theme.palette.neutralWhite,
  },
  formActions: {
    float: 'right',
    paddingTop: pxToRem(20),
    paddingBottom: pxToRem(20),
  },
  loadingSpinner: {
    marginLeft: pxToRem(10),
  },
  royaltyFeeForm: {
    paddingTop: pxToRem(20),
    paddingBottom: pxToRem(20),
    marginLeft: pxToRem(24),
    marginRight: pxToRem(24),
  },
});
